/**
 * @author gyb(mocheer)
 * @since 2017.7.11
 */
// import {distance} from './Util'
/**
 * n次贝塞尔曲线
 * @param arr [[x,y],[x,y]]
 */
export var bezier = (arr, step) => {
  let points = [arr[0]];//第一个点
  let l = arr.length;
  for (let i = step; i < 1; i += step) {
    points.push(PBezier(arr, l, i));
  }
  points.push(arr[l - 1]);
  return points;
}
/** 
 * 燕尾、军标箭头
 * @param arr
 * @param step
 * @param options
 */
export var coattail = (arr, step, options) => {
  let { r, ra, ma } = T.assign({
    r: 36,     //箭头两边长度
    ra: 0.2,   //张开弧度系数
    ma: 16     //最大宽度
  }, options);
  let { PI } = Math;
  //
  let points = [arr[0]];// 第一个点
  let l = arr.length; //
  let p0 = arr[0]; // 上个点
  let num = Math.ceil((1 / step) + 1) * 2;// 贝塞尔曲线上的点数
  let ci = 1, p;
  if (l < 2) return arr;
  // 贝塞尔
  for (let i = step; i < 1; i += step, ci++) {
    p = PBezier(arr, l, i);//当前点
    let r = ma - i * 9;    //半径
    let radians = Math.atan2(p[1] - p0[1], p[0] - p0[0]) - Math.PI / 2;
    let offsetX = r * Math.cos(radians);
    let offsetY = r * Math.sin(radians);
    points[ci] = [p[0] + offsetX, p[1] + offsetY];
    points[num - ci] = [p[0] - offsetX, p[1] - offsetY];
    p0 = p;
  }
  // 箭头
  p = arr[l - 1];
  let radians = Math.atan2(p[1] - p0[1], p[0] - p0[0]);
  p = [p0[0] + (ma + 2) * Math.cos(radians), p0[1] + (ma + 2) * Math.sin(radians)];
  points[ci++] = [p[0] + r * Math.cos(PI * (1 + ra) + radians), p[1] + r * Math.sin(PI * (1 + ra) + radians)]
  points[ci++] = p;
  points[ci] = [p[0] + r * Math.cos(PI * (1 - ra) + radians), p[1] + r * Math.sin(PI * (1 - ra) + radians)]
  // 最后一个点 
  points.push(arr[0]);
  return points;
}
//
let PBezier = (arr, l, t) => {
  let px = 0,
    py = 0,
    n = l - 1;//n次
  for (let i = 0, b; i < l; i++) {
    b = BEZ(n, i, t);
    px += arr[i][0] * b;
    py += arr[i][1] * b;
  }
  return [px, py]
}
//基函数
let BEZ = (n, k, t) => {
  return C(n, k) * Math.pow(t, k) * Math.pow(1 - t, n - k);
}
//组合排序
let C = (n, k) => {
  return Factorial(n) / (Factorial(k) * Factorial(n - k));
}
//阶乘
let Factorial = i => {
  let n = 1;
  for (let j = 1; j <= i; j++) {
    n *= j;
  }
  return n;
}


// WEBPACK FOOTER //
// ./src/utils/Bezier.js